module.exports = __webpack_public_path__ + "img/Rel.Colleagues@3x.54850062.png";